import { render, staticRenderFns } from "./UserCarDetail.vue?vue&type=template&id=52c5916b&scoped=true"
import script from "./UserCarDetail.vue?vue&type=script&lang=js"
export * from "./UserCarDetail.vue?vue&type=script&lang=js"
import style0 from "./UserCarDetail.vue?vue&type=style&index=0&id=52c5916b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c5916b",
  null
  
)

export default component.exports